import React from "react";
import PropTypes from "prop-types";
import ResultContainer from "../containers/ChainReactionGame/ResultContainer";
import SidebarContainer from "../containers/ChainReactionGame/SidebarContainer";
import './ResultScreen.css';

const LandingScreen = props => {

  const { transitionOut, delay } = props;

  return (
    <div className="result-screen">
      <SidebarContainer />
      <ResultContainer 
        transitionOut={transitionOut}
      />
    </div>
  );
};

LandingScreen.propTypes = {
  transitionOut: PropTypes.func.isRequired,
  delay: PropTypes.number
};

export default LandingScreen;



// WEBPACK FOOTER //
// ./src/components/ResultScreen.jsx